import React from 'react';

import { IIconProps, TIconType } from '../interface';

const DashboardIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<rect
				fill={props?.isActive ? 'currentColor' : props?.color}
				height='9'
				rx='0.7'
				stroke='currentColor'
				strokeLinejoin='round'
				width='7'
				x='3.5'
				y='3.5'
			/>
			<rect
				fill={props?.isActive ? 'currentColor' : props?.color}
				height='9'
				rx='0.7'
				stroke='currentColor'
				strokeLinejoin='round'
				width='7'
				x='12.5'
				y='10.5'
			/>
			<rect
				fill={props?.isActive ? 'currentColor' : props?.color}
				height='5'
				rx='0.7'
				stroke='currentColor'
				strokeLinejoin='round'
				width='7'
				x='12.5'
				y='3.5'
			/>
			<rect
				fill={props?.isActive ? 'currentColor' : props?.color}
				height='5'
				rx='0.7'
				stroke='currentColor'
				strokeLinejoin='round'
				width='7'
				x='3.5'
				y='14.5'
			/>
		</svg>
	);
};

export default DashboardIcon;
